// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".QK\\+5{background-color:var(--grey-900);border-radius:32px;margin:0 auto;max-width:352px;overflow:hidden;padding:8px;width:100%}.i6de{align-items:center;display:flex;gap:8px;justify-content:center;padding-bottom:8px}.FBfh{background-color:var(--white);border-radius:24px;height:622px;overflow:hidden;position:relative;width:100%}.JZdC,.YDu-{background-color:var(--grey-800);border-radius:8px;display:flex;height:8px}.JZdC{width:8px}.YDu-{width:60px}.qtpb{display:flex;flex-direction:column;gap:8px;height:100%;left:0;padding:8px;position:absolute;top:0;width:100%;z-index:1}.qtpb>section{background-color:var(--blue-shade-4);border-radius:16px}.qtpb>section:first-child{height:80px}.qtpb>section:nth-child(2){height:100%}.hf1g{height:100%;position:relative;z-index:2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionPreviewTypeMobile": "QK+5",
	"actionPreviewTypeMobileHeader": "i6de",
	"actionPreviewTypeMobileBody": "FBfh",
	"actionPreviewTypeMobileHeaderCamera": "JZdC",
	"actionPreviewTypeMobileHeaderMicro": "YDu-",
	"actionPreviewTypeMobileBodySkeleton": "qtpb",
	"actionPreviewTypeMobileBodyCtx": "hf1g"
};
module.exports = ___CSS_LOADER_EXPORT___;
